import { useQuery } from "@tanstack/react-query";
import { getFileURL } from "../../../utils/GeneralUtils";

export default function useImage(
  pathname: string,
  tenantID?: string,
  isSupportal?: boolean
) {
  const image = useQuery({
    queryKey: ["image", pathname],
    queryFn: () => getImage(pathname, tenantID, isSupportal),
    enabled: !!pathname,
    staleTime: Infinity,
  });

  return { fileURL: image.data || "", loading: image.isLoading };
}

export const getImage = async (
  pathname: string,
  tenantID?: string,
  isSupportal?: boolean
) => {
  if (!pathname) return "";

  // It's a public url
  if (pathname.startsWith("https") && pathname.includes("-public"))
    return pathname;

  if (sessionStorage.getItem("gcimg_" + pathname)) {
    try {
      const cached = JSON.parse(
        // @ts-ignore - Error handler for a reason Typescript.
        sessionStorage.getItem("gcimg_" + pathname)
      );
      const now = new Date();

      if (cached?.url && now.getTime() <= cached?.expires) {
        return cached.url;
      } else {
        sessionStorage.removeItem("gcimg_" + pathname);
      }
    } catch (e) {
      sessionStorage.removeItem("gcimg_" + pathname);
    }
  }

  try {
    const url = await getFileURL(pathname, undefined, isSupportal, tenantID);

    const now = new Date();
    const expires = now.getTime() + 60 * 60 * 1000; // 1 hour expiration

    if (url) {
      sessionStorage.setItem(
        "gcimg_" + pathname,
        JSON.stringify({ url, expires })
      );
    }

    return url;
  } catch (e) {
    sessionStorage.removeItem("gcimg_" + pathname);

    return "";
  }
};
